var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "letter-i 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3672 10C18.3672 14.6211 14.6211 18.3672 10 18.3672C5.37893 18.3672 1.63281 14.6211 1.63281 10C1.63281 5.37893 5.37893 1.63281 10 1.63281C14.6211 1.63281 18.3672 5.37893 18.3672 10Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0117 6.41679C9.73982 6.42284 9.47535 6.32777 9.26953 6.15C9.06354 5.97187 8.96055 5.72005 8.96055 5.39453C8.9568 5.25731 8.98323 5.12094 9.03797 4.99506C9.09271 4.86917 9.17442 4.75685 9.27734 4.66601C9.47689 4.47981 9.74037 4.37744 10.0133 4.38008C10.2758 4.37744 10.5304 4.46953 10.7305 4.63945C10.9388 4.81211 11.043 5.0638 11.043 5.39453C11.043 5.71484 10.9413 5.96536 10.7379 6.14609C10.5389 6.32504 10.2793 6.42179 10.0117 6.41679ZM11.0418 8.56836V14.5879C11.0418 15.0046 10.9426 15.3199 10.7441 15.534C10.6487 15.6385 10.5319 15.7213 10.4016 15.7766C10.2713 15.832 10.1306 15.8586 9.98906 15.8547C9.68359 15.8547 9.43555 15.7453 9.24492 15.5266C9.0543 15.3078 8.95898 14.9953 8.95898 14.5891V8.62929C8.95898 8.21758 9.0543 7.90742 9.24492 7.69882C9.43555 7.49023 9.68359 7.38606 9.98906 7.38632C10.294 7.38632 10.5457 7.49049 10.7441 7.69882C10.9426 7.90716 11.0418 8.197 11.0418 8.56836Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWhite);
export default __webpack_public_path__ + "static/media/info-white.25552d6d25143319e89108081b0e1ba6.svg";
export { ForwardRef as ReactComponent };